import { TextField } from "@mui/material";
import { useModalOfferContext } from "../context";
import { requiredForContractType } from "../logics/logics";

export const WeeklyDurationInput = () => {
  const { offer, setOffer, disabled, errors, setErrors, applyFollowUp, apply } = useModalOfferContext();
  const required = applyFollowUp && apply.status === "success";

  return (
    <TextField
      label={required && requiredForContractType(offer) ? "Durée hebdo (en heures)*" : "Durée hebdo (en heures)"}
      type="number"
      size="small"
      fullWidth
      value={offer?.workWeeklyDuration || ""}
      onChange={(evt) => {
        setOffer((offer) => ({ ...offer, workWeeklyDuration: Number.parseInt(evt.target.value, 10) }));
        setErrors((errors) => ({ ...errors, workWeeklyDuration: false }));
      }}
      disabled={disabled}
      error={errors.workWeeklyDuration}
      slotProps={{
        htmlInput: { min: 0, max: 100 },
      }}
    />
  );
};
